<template lang="pug">
	.ai-music--linked-stations
		ListViewLinkUnlink(ref="links", :rootItemId="id", :rootObjectTypeId="$Data.objectTypes.AiMusic", :allItemsRequest="(pIdx, limit, opts) => $Data.getExternalStations(pIdx, limit, { ...(opts || {}), onlyMyStations: true, allCountries: true })", 
			:linkedItemsRequest="getLinkedItems", collectionField="Stations", :searchPanelWidth="480", @linked-items="v => $emit('stations', v || [])")
			template(slot="left-actions")
				.font-big.upper.grey {{$tCaption('Stations')}}
			template(v-slot:item="{ item }")
				StationRowItem(:item="item")
</template>

<script>	
	import ListViewLinkUnlink from 'app-core/ListViewLinkUnlink.vue';
	import StationRowItem from 'view/station/RowItem.vue';

	export default {
		translationCategory: 'aiMusic.LinkedStations',
		name: 'ai-music--linked-stations',
		components: { ListViewLinkUnlink, StationRowItem },
		props: ['id'],
		data() {
			return {
			};
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.aiMusicLinkedStations = this;
		},
		destroyed() {
			
		},
		methods: {
			getLinkedItems(pageIndex, limit, opts, targetId) {
				if (opts?.byKey)
					return this.$Data.getExternalApi('Station/Get', `id=${opts.byKey}`).then(r => ({ Results: r }));
				opts = { defSorting: [ { selector: 'Name' }], ...(opts || {}) };
				return this.$Data.getExternalApi('AiMusic/GetCollectionStations', `page=${pageIndex + 1}&musicId=${targetId}${this.$Data.getFilterCriteriaSortingParams(opts)}`, limit).then(r => {
					this.$emit('stations', r?.Results || []);
					return r;
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ai-music--linked-stations {
		
	}
</style>
 